/* Sommerfeld cart drawer — live updates for the tier ladder + checkout-button total.
   The theme's AJAX refresh only swaps the line items + price region, so the ladder
   (top of drawer) and the total inside the checkout button are updated here. */
(function () {
  'use strict';

  var CART_EVENTS = [
    'theme:cart:change',
    'theme:cart:refresh',
    'theme:cart:added',
    'theme:cart:add',
    'theme:product:added',
    'theme:cart:update'
  ];

  function defaultTo(v, d) { return v == null ? d : v; }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) return '0';
    number = (number / 100).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var frac = parts[1] ? decimal + parts[1] : '';
    return whole + frac;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var value = '';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(re);
    var placeholder = match ? match[1] : 'amount';
    switch (placeholder) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(re, value);
  }

  function num(el, attr, fallback) {
    var v = parseInt(el.getAttribute(attr), 10);
    return isNaN(v) ? fallback : v;
  }

  function updateLadder(count) {
    var ladder = document.querySelector('[data-sf-ladder]');
    if (!ladder) return;

    var t1 = num(ladder, 'data-sf-t1', 2);
    var t2 = num(ladder, 'data-sf-t2', 3);
    var t3 = num(ladder, 'data-sf-t3', 4);
    var t4 = num(ladder, 'data-sf-t4', 5);
    var p1 = num(ladder, 'data-sf-p1', 10);
    var p2 = num(ladder, 'data-sf-p2', 15);
    var p3 = num(ladder, 'data-sf-p3', 20);
    var p4 = num(ladder, 'data-sf-p4', 25);

    var nextMin = 0, nextPct = 0;
    if (count < t1) { nextMin = t1; nextPct = p1; }
    else if (count < t2) { nextMin = t2; nextPct = p2; }
    else if (count < t3) { nextMin = t3; nextPct = p3; }
    else if (count < t4) { nextMin = t4; nextPct = p4; }

    // The ladder of 2026-10-11 has no sentence: a label under each segment, written from the cart.
    // Its templates travel in data attributes, as the sentence's do, so this file holds no words.
    // A ladder without these attributes is the one before it, handled by the lines further down.
    if (ladder.hasAttribute('data-sf-lbl-on')) {
      var tiers = [[t1, p1], [t2, p2], [t3, p3], [t4, p4]];
      var reached = 0;
      for (var r = 0; r < tiers.length; r++) if (count >= tiers[r][0]) reached++;
      var labels = ladder.querySelectorAll('[data-sf-step]');
      for (var k = 0; k < labels.length && k < tiers.length; k++) {
        var more = tiers[k][0] - count;
        var name, state = '';
        if (k < reached) {
          // «extra» on the last step she has, but not in the middle slot: the next label needs the room
          name = (k === reached - 1 && k !== 1) ? 'data-sf-lbl-on-last' : 'data-sf-lbl-on';
          state = 'is-on';
        } else if (k === reached) {
          name = more === 1 ? 'data-sf-lbl-next-one' : 'data-sf-lbl-next-many';
          state = 'is-next';
        } else {
          name = 'data-sf-lbl-later';
        }
        labels[k].textContent = (ladder.getAttribute(name) || '').replace('{n}', more).replace('{pct}', tiers[k][1]);
        labels[k].className = state;
      }
    }

    var msg = ladder.querySelector('[data-sf-ladder-msg]');
    if (msg) {
      // Plain text, no <strong> - the reference's message is uniform weight. The wording comes from
      // the snippet through data attributes, so this file holds no language of its own.
      var templateMax = ladder.getAttribute('data-sf-msg-max') || '';
      if (nextMin > 0) {
        var remaining = nextMin - count;
        // Greek agrees the verb with the number, «Σας λείπει» against «Σας λείπουν», so each
        // count carries its own whole sentence rather than a shared one with the noun swapped.
        var templateNext = ladder.getAttribute(
          remaining === 1 ? 'data-sf-msg-next-one' : 'data-sf-msg-next-many'
        ) || '';
        msg.textContent = templateNext
          .replace('{n}', remaining)
          .replace('{pct}', nextPct)
          .replace(/&nbsp;/g, '\u00a0');
      } else {
        msg.textContent = templateMax.replace('{pct}', p4).replace(/&nbsp;/g, '\u00a0');
      }
    }

    var nodes = ladder.querySelectorAll('.sf-ladder__node');
    for (var i = 0; i < nodes.length; i++) {
      var min = num(nodes[i], 'data-sf-step', 0);
      nodes[i].classList.toggle('is-done', count >= min);
    }

    // Per-segment fill: progress through each segment's OWN span, so 1 item fills
    // segment 1 to 50% (half way to the 2-item tier) rather than showing nothing.
    function segPct(from, to) {
      if (to <= from) return count >= to ? 100 : 0;
      var p = ((count - from) / (to - from)) * 100;
      return Math.max(0, Math.min(100, p));
    }
    var fills = [segPct(0, t1), segPct(t1, t2), segPct(t2, t3), segPct(t3, t4)];
    for (var s = 1; s <= 4; s++) {
      var el = ladder.querySelector('[data-sf-fill="' + s + '"]');
      if (el) el.style.width = fills[s - 1] + '%';
    }
  }

  function updateTotal(totalPrice) {
    var el = document.querySelector('[data-sf-cart-total]');
    if (!el) return;
    var fmt = window.sfCartMoneyFormat || (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    el.innerHTML = formatMoney(totalPrice, fmt);
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateLadder(cart.item_count);
        updateTotal(cart.total_price);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var timer = null;
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  CART_EVENTS.forEach(function (evt) {
    document.addEventListener(evt, scheduleRefresh);
  });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
